// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { SettingBase_abstract } from './../abstract/SagaBase/SettingBase_abstract';
export class SettingBase extends SettingBase_abstract {}
